export default __webpack_public_path__ + "static/media/Montserrat-Black.e4ac0e21.ttf";